// src/components/BoardPack/pages/kpi_chart_12.jsx
import React, { useState, useEffect, useRef } from "react";
import { apiCall } from "@/api/apiCall";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import { useQueue } from "@/context/QueueContext";
import ReusableKPIChart from "@/components/BoardPack/components/charts/ReusableKPIChart";

const KpiChart12 = ({  page = null }) => {
  const { enqueue } = useQueue();

  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetchedRef = useRef(false);

  const transformApiData = (apiData) => {
    const contractName = Object.keys(apiData.data);
    if (!apiData?.data || !apiData.data[contractName]) {
      return [];
    }
    const contractData = apiData.data[contractName];
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];

    // ✅ Fixed: null/undefined/empty → 0, NaN → 0
    const safeFloat = (value) => {
      if (value === null || value === undefined || value === "" || value === "-") return 0;
      const parsed = parseFloat(typeof value === "string" ? value.replace(/,/g, "") : value);
      return isNaN(parsed) ? 0 : parsed;
    };

    const transformedData = [];

    console.log("contract", contractData);
    const year = Object.keys(contractData.Parking_Revenue_in_RC);

    // ✅ Fixed: "month in yearData" — 0 value wale months bhi push honge
    // Process year[0] data
    months.forEach((month) => {
      const yearData = contractData.Parking_Revenue_in_RC?.[year[0]];
      if (yearData && month in yearData) {
        transformedData.push({
          month: `${month}-${year[0]}`,
          year: year[0],
          revenue: safeFloat(contractData.Parking_Revenue_in_RC?.[year[0]]?.[month]),
          transaction: safeFloat(contractData.Ticket_Count?.[year[0]]?.[month]),
          atv: safeFloat(contractData.ATV?.[year[0]]?.[month]),
          als: safeFloat(contractData.ALS?.[year[0]]?.[month]),
        });
      }
    });

    // Process year[1] data
    months.forEach((month) => {
      const yearData = contractData.Parking_Revenue_in_RC?.[year[1]];
      if (yearData && month in yearData) {
        transformedData.push({
          month: `${month}-${year[1]}`,
          year: year[1],
          revenue: safeFloat(contractData.Parking_Revenue_in_RC?.[year[1]]?.[month]),
          transaction: safeFloat(contractData.Ticket_Count?.[year[1]]?.[month]),
          atv: safeFloat(contractData.ATV?.[year[1]]?.[month]),
          als: safeFloat(contractData.ALS?.[year[1]]?.[month]),
        });
      }
    });

    return transformedData;
  };

  useEffect(() => {
    // if (!year || !month || !contract) return;
    // if (hasFetchedRef.current) return;

    // hasFetchedRef.current = true;
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

    //   const params = {
    //     contract: page?.params?.contract,
    //     year: year,
    //     month: month,
    //     kpi: page?.params?.kpi,
    //   };

    //   const response = await enqueue(() => apiCall("GET", "/board-pack/page-twelve", params));

    const response = {
    "success": true,
    "meta": {
        "contract": "0020013",
        "year": 2026,
        "month": "Apr",
        "kpi": "revenue"
    },
    "data": {
        "0020013 - TAIF ON STREET": {
            "Parking_Revenue_in_RC": {
                "2025": {
                    "Jan": "396,713",
                    "Feb": "449,362",
                    "Mar": "656,269",
                    "Apr": "346,169",
                    "May": "351,308",
                    "Jun": "378,491",
                    "Jul": "429,401",
                    "Aug": "429,672",
                    "Sep": "360,285",
                    "Oct": "360,721",
                    "Nov": "391,233",
                    "Dec": "406,515"
                },
                "2026": {
                    "Jan": "420,988",
                    "Feb": "491,373",
                    "Mar": "540,229",
                    "Apr": "70,784"
                }
            },
            "Ticket_Count": {
                "2025": {
                    "Jan": "130,452",
                    "Feb": "147,120",
                    "Mar": "219,209",
                    "Apr": "115,958",
                    "May": "125,609",
                    "Jun": "127,814",
                    "Jul": "144,432",
                    "Aug": "142,001",
                    "Sep": "124,233",
                    "Oct": "124,224",
                    "Nov": "133,926",
                    "Dec": "137,483"
                },
                "2026": {
                    "Jan": "140,118",
                    "Feb": "162,266",
                    "Mar": "182,082",
                    "Apr": "24,079"
                }
            },
            "ATV": {
                "2025": {
                    "Jan": "3.04",
                    "Feb": "3.05",
                    "Mar": "2.99",
                    "Apr": "2.99",
                    "May": "2.80",
                    "Jun": "2.96",
                    "Jul": "2.97",
                    "Aug": "3.03",
                    "Sep": "2.90",
                    "Oct": "2.90",
                    "Nov": "2.92",
                    "Dec": "2.96"
                },
                "2026": {
                    "Jan": "3.00",
                    "Feb": "3.03",
                    "Mar": "2.97",
                    "Apr": "2.94"
                }
            },
            "ALS": {
                "2025": {
                    "Jan": "1.44",
                    "Feb": "1.48",
                    "Mar": "1.58",
                    "Apr": "1.48",
                    "May": "1.47",
                    "Jun": "1.48",
                    "Jul": "1.51",
                    "Aug": "1.53",
                    "Sep": "1.44",
                    "Oct": "1.46",
                    "Nov": "1.44",
                    "Dec": "1.43"
                },
                "2026": {
                    "Jan": "1.47",
                    "Feb": "1.56",
                    "Mar": "1.55",
                    "Apr": "1.48"
                }
            }
        }
    }
};

      if (response?.success) {
        const transformed = transformApiData(response);
        setChartData(transformed);
      } else {
        setError(response?.message || "Failed to load data. Please try again later.");
      }
    } catch (err) {
      setError(err?.message || "Failed to load data. Please try again later.");
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} onRetry={fetchData} />;

  return (
    <ReusableKPIChart
      chartData={chartData}
      title={page?.title}
      subtitle={page?.subtitle}
      chartTitle={page?.in_chart_content_line_1}
      colors={page?.colors}
      labels={page?.labels}
      showDataLabels={page?.showDataLabels ? true : false}
      showRamadanRow={true}
      yAxisLabel={page?.yAxisLabel}
      ramadanBorderColor="#00d4ff"
      yAxisFormatters={{
        left: (value) => (value / 1000000).toFixed(1) + "M",
        right: (value) => value,
      }}
    />
  );
};

export default KpiChart12;